import * as React from 'react';
import { useNavigate, useLocation } from "react-router-dom";

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleNav = (page) => {
        navigate(`/BackOffice/${page}`);
    };

    const handleHome = () => {
        navigate('/BackOffice/Home');
    };

    const handleBack = () => {
        navigate(-1); // go back one page in history
    };

    return (
        <Box sx={{ flexGrow: 1, p: 2 }}>
            <AppBar position="static" sx={{ color: 'black', bgcolor: 'white' }}>
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        BackOffice
                    </Typography>
                    <Box sx={{ flexGrow: 1, p: 2 }}>
                        <Button onClick={() => handleHome} disabled={location.pathname.includes("Home")}color="inherit">Home</Button>
                        <Button onClick={() => handleNav('Keys')} disabled={location.pathname.includes("Keys")} color="inherit">API Keys</Button>
                        <Button onClick={() => handleNav('Events')} disabled={location.pathname.includes("Events")} color="inherit">Events</Button>
                        <Button onClick={() => handleNav('Audits')} disabled={ location.pathname.includes("Audits")} color="inherit">User Audits</Button>
                        <Button onClick={() => handleNav('Settings')} disabled={location.pathname.includes("Settings")} color="inherit">Tennant Settings</Button>
                    </Box>
                    <Button onClick={handleBack} color="inherit">Back</Button>
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default Header;
